module.exports = __webpack_public_path__ + "img/0005.f0fd3169.png";